import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { AccesoGuardService } from './services/acceso-guard.service';
import { PreviewModule } from './pages/preview/preview.module';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { 
        path: 'pages', 
        component: PagesComponent, children: [
            { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', data: { key: 'DASH', breadcrumb: 'Dashboard' }, canActivate:[AccesoGuardService] },
            { path: 'maps', loadChildren: './pages/maps/maps.module#MapsModule', data: { key: 'MAPS', breadcrumb: 'Maps' }, canActivate:[AccesoGuardService] },
            //PANTALLAS DE PROCESOS
            { path: 'preliquidaciones', loadChildren: './pages/catalogos/preliquidaciones/preliquidaciones.module#PreliquidacionesModule', data: { key: 'PREL', breadcrumb: 'Preliquidaciones' }, canActivate:[AccesoGuardService] },
            { path: 'panel-preliquidacion/:id', loadChildren: './pages/catalogos/panel-preliquidacion/panel-preliquidacion.module#PanelPreliquidacionModule', data: { key: 'PREL', breadcrumb: 'Panel de preliquidaciones' }, canActivate:[AccesoGuardService] },
            { path: 'usuarios', loadChildren: './pages/catalogos/usuarios/usuarios.module#UsuariosModule', data: { key: 'USUA', breadcrumb: 'Usuarios' }, canActivate:[AccesoGuardService] },
            { path: 'productos', loadChildren: './pages/catalogos/productos/productos.module#ProductosModule', data: { key: 'PROD', breadcrumb: 'Seguimiento a clientes' }, canActivate:[AccesoGuardService] },
            { path: 'facturas', loadChildren: './pages/facturas/facturas.module#FacturasModule', data: { key: 'FACT', breadcrumb: 'Facturas' }, canActivate:[AccesoGuardService] },
        ]
    },
    { path: 'login', loadChildren: './pages/login/login.module#LoginModule' },
    { path: 'preview', loadChildren: './pages/preview/preview.module#PreviewModule'},
    { path: 'sandbox', loadChildren: './pages/sandbox/sandbox.module#SandboxModule'},
    { path: 'error', component: ErrorComponent, data: { breadcrumb: 'Error' } },
    { path: '**', component: NotFoundComponent },

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
   preloadingStrategy: PreloadAllModules,  // <- comment this line for activate lazy load
   // useHash: true
});